module.exports = __webpack_public_path__ + "img/about-old.3976d254.png";